import * as React from 'react';
import { TableCell } from '../TableCell';
import { UIText2 } from '@cian/ui-kit';
import { formatMoney } from '../../../../../../../../utils/string';
import * as styles from './PriceCell.css';

interface IProps {
  price: number;
  marketingPrice?: number;
}

export const PriceCell = (props: IProps) => {
  const { price, marketingPrice } = props;

  return (
    <TableCell>
      {!!marketingPrice && (
        <span className={styles['marketing_price']}>
          <UIText2 color="gray60_100" display="inline">
            {formatMoney(marketingPrice)}
          </UIText2>
        </span>
      )}

      <UIText2 color="black_100" display="inline">
        {formatMoney(price || 0)}
      </UIText2>
    </TableCell>
  );
};
